/* globals $, globalScene, allTweens, controller */
import { TimelineMax, Power2 } from 'gsap';
import 'gsap/ScrollToPlugin';

import resizeThrottler from 'helpers/resizeThrottler';
import ScrollMagic from 'helpers/importers/ScrollMagic';
import calculateOffset from 'helpers/calculateOffset';

class FranchiseScene {
  constructor () {
    this.id = null;
    this.pscene = null;
    this.sceneStart = null;
    this.sceneParalax = null;
    this.scene = null;
    this.sceneEnd = null;
    this.sceneLast = null;
    this.offset = [-200, -400, -100, 20, -75];
  }

  initParallax (id) {
    let count = 1;
    this.pscene = $('#game-' + id + '  .parallax .field-items');
    this.pscene.children('.field-item').each(function () {
      $(this).attr('data-depth', (20 * (count++)) / 100);
    });
    //this.pscene.parallax();
  }

  updateOffsets () {
    this.sceneStart.offset(calculateOffset(this.offset[0]));
    this.sceneParalax.offset(calculateOffset(this.offset[1]));
    this.scene.offset(calculateOffset(this.offset[2]));
    this.sceneEnd.offset(calculateOffset(this.offset[3]));
  }

  init (id, last) {
    this.id = id;
    let tween = new TimelineMax({
      pause: true,
      onComplete: () => {
        //self.pscene.parallax('enable');
      },
    });

    this.initParallax(id);

    $(window).on('resize', () => resizeThrottler(this.updateOffsets, 66));

    if ((id % 2 !== 0)) {
      tween.fromTo($('#game-' + id + '  .content-column'), 0.5, {
        xPercent: -100,
      }, {
        xPercent: 0,
        ease: Power2.easeOut,
      });
      tween.fromTo($('#game-' + id + ' .image-column  blockquote'), 0.5, {
        xPercent: 100,
      }, {
        xPercent: 0,
        ease: Power2.easeOut,
      });
    } else {
      tween.fromTo($('#game-' + id + '  .content-column'), 0.5, {
        xPercent: 100,
      }, {
        xPercent: 0,
        ease: Power2.easeOut,
      });
      tween.fromTo($('#game-' + id + '  .image-column blockquote'), 0.5, {
        xPercent: -100,
      }, {
        xPercent: 0,
        ease: Power2.easeOut,
      });
    }

    this.sceneStart = new ScrollMagic.Scene({
      triggerElement: '#game-' + id + ' ',
      offset: calculateOffset(this.offset[0]),
      duration: 0,
      triggerHook: 'onLeave',
    })
    //.addIndicators({name: "start_item_"+id})
    .setTween(tween);

    this.sceneParalax = new ScrollMagic.Scene({
      triggerElement: '#game-' + id + ' ',
      duration: '100%',
      triggerHook: 'onEnter',
    });
    //.addIndicators({name: "Parallax_item_"+id})


    this.sceneEnd = new ScrollMagic.Scene({
      triggerElement: '#game-' + id + ' ',
      offset: calculateOffset(this.offset[3]),
      duration: '0',
      triggerHook: 'onLeave',
    });
    //.addIndicators({name: "END_item" + id});

    if (last) {
      this.sceneLast = new ScrollMagic.Scene({
        triggerElement: last,
        offset: this.offset[4],
        triggerHook: 'onLeave',
      });
      // .addIndicators({name: "last"});

      this.sceneLast.enabled(false);
      this.sceneLast.addTo(controller);
      globalScene.push(this.sceneLast);
    }

    this.sceneParalax.on('enter', _e => {
      //self.pscene.parallax('enable');
    });

    this.sceneParalax.on('leave', _e => {
      //self.pscene.parallax('disable');
    });

    this.sceneStart.enabled(false);
    this.sceneParalax.enabled(false);
    this.sceneEnd.enabled(false);

    this.sceneStart.addTo(controller);
    this.sceneParalax.addTo(controller);
    this.sceneEnd.addTo(controller);

    globalScene.push(this.sceneStart);
    globalScene.push(this.sceneParalax);
    globalScene.push(this.sceneEnd);

    allTweens.push(tween);

    return this;
  }
}

export default function franchisesScene () {
  let el = $('#franchises .view-games .view-content').children().length;
  let sceneArray = [];
  for (let i = 1; i <= el; i++) {
    let scene = new FranchiseScene();
    scene.init(i, (i !== el) ? false : '#studio');
    sceneArray.push(scene);

  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/franchiseScene.js